import { PATIENT_STATEMENTS, USERS } from '../../../collections/names'

export const getPatientStatementsCollectionPath = (patientId: string) =>
  `${USERS}/${patientId}/${PATIENT_STATEMENTS}`
